import { IActionGroup, IStore } from '../index';
import { IHeaderStore } from './store';

export interface IHeaderActions {
  setTitle: (title: string) => { header: IHeaderStore };
}

const actions: IActionGroup = {
  setTitle: (state: IStore, title: string): { header: IHeaderStore } => {
    const { header } = state;
    header.title = title;
    return { header };
  }
};

export default actions;
